import { jsonProperty, Serializable } from 'ts-serializable';

export class GetSurveyDto extends Serializable {
  @jsonProperty(String, null) carId: string | undefined = undefined;
  @jsonProperty(String, undefined) workOrderId: string | undefined = undefined;
}
